import React from "react";
import { Row, Col, Button } from "antd";
import { ArrowLeftOutlined } from "@ant-design/icons";
import MetricCard from "@/components/UI/Cards/adminStatCard";
import BestsellerProducts from "./sections/bestSellerCard";
import TopPerformingCategories from "./sections/topCategories";
import SalesByDevice from "./sections/deviceSales";
import StatGlance from "./sections/statGlance";

import { formatCurrency, formatNumber, formatPercentage } from "@/utils/helper";
import { useGetMonthlyStatsQuery } from "@/services/api/dashboard/dashboardApi";
import DailyOrders from "./sections/DailyOrders";

// const { Option } = Select;

const Dashboard = () => {
  const { data: monthlyStats } = useGetMonthlyStatsQuery();

  const getTrend = (current, previous) => {
    if (current > previous) return "up";
    if (current < previous) return "down";
    return "none";
  };

  const statsData = [
    {
      title: "Total Sales",
      value: formatCurrency(monthlyStats?.current_month.sales, { decimals: 0 }),
      change: formatPercentage(monthlyStats?.change.sales),
      trend: getTrend(
        monthlyStats?.current_month.sales,
        monthlyStats?.previous_month.sales
      ),
    },
    {
      title: "Total Orders",
      value: formatNumber(monthlyStats?.current_month.orders, { decimals: 0 }),
      change: formatPercentage(monthlyStats?.change.orders),
      trend: getTrend(
        monthlyStats?.current_month.orders,
        monthlyStats?.previous_month.orders
      ),
    },
    {
      title: "Total Customers",
      value: formatNumber(monthlyStats?.current_month.customers, {
        decimals: 0,
      }),
      change: formatPercentage(monthlyStats?.change.customers),
      trend: getTrend(
        monthlyStats?.current_month.customers,
        monthlyStats?.previous_month.customers
      ),
    },
  ];

  return (
    <div className="px-6 bg-gray-50 min-h-full">
      {/* Main Stats Grid */}
      <Row gutter={[12, 12]} className="mb-8 ">
        <Col xs={24} lg={10} className="">
          <Row gutter={[16, 0]}>
            {statsData.map((stat, index) => (
              <Col key={index} xs={24} md={8} lg={12} className="mb-4 ">
                <MetricCard
                  title={stat.title}
                  value={stat.value}
                  change={stat.change}
                  changeType={
                    stat.trend === "up"
                      ? "increase"
                      : stat.trend === "down"
                      ? "decrease"
                      : "nochange"
                  }
                  showMorebutton={true}
                  // showTrendtag={true}
                />
              </Col>
            ))}
          </Row>
        </Col>
        {/* Daily Orders Bar Chart */}
        <Col xs={24} lg={14}>
          <DailyOrders />
        </Col>
      </Row>

      {/* Stats at a Glance */}
      <StatGlance />

      {/* Top Products and Categories */}
      <Row gutter={[16, 16]} className="my-8">
        <Col xs={24} lg={8}>
          <BestsellerProducts />
        </Col>
        <Col xs={24} lg={8}>
          <TopPerformingCategories />
        </Col>
        <Col xs={24} lg={8}>
          <SalesByDevice />
        </Col>
      </Row>
    </div>
  );
};

export default Dashboard;
